import { PasswordChangeCardView } from "./password-change-card-view";

export const PasswordChangeCard = (props: {
	value?: string;
	onChangePassword?: () => void;
}) => {
	return <PasswordChangeCardView {...props} />;
};
